// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1458":"964e46bd","2364":"5908039b","4027":"eea807ab"}[chunkId] + ".chunk.css";
};